export default "__VITE_ASSET__aa896576__"